var $f8eb710b9573f592$exports = {};
$f8eb710b9573f592$exports = {
    "maximum": `Maksimum`,
    "minimum": `Minimum`
};


export {$f8eb710b9573f592$exports as default};
//# sourceMappingURL=pl-PL.module.js.map
